import { object, string, ref } from 'yup';
import { TFunction } from 'i18next';

export function makeRegistrationSchema(t: TFunction) {
  return object().shape({
    oldPassword: string().email(t('form.emailInvalid')).required(t('form.required')),
    password: string()
      .required(t('form.required'))
      .matches(new RegExp(String.raw`^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.{8,})`), t('form.passwordInvalid')),
    passwordAgain: string()
      .required(t('form.required'))
      .oneOf([ref('password'), null] as any, t('form.passwordsMustMatch')),
  });
}
